import { cn } from '../../lib/cn';

export function Select({ className, label, error, options = [], placeholder, ...props }) {
  return (
    <div className="flex flex-col gap-1.5">
      {label && <label className="text-[13px] font-medium text-[var(--text-primary)]">{label}</label>}
      <select
        className={cn('w-full h-10 px-3 pr-8 bg-[var(--bg-card)] border border-[var(--border)] rounded-[10px] text-[14px] text-[var(--text-primary)] appearance-none cursor-pointer focus:outline-none focus:ring-2 focus:ring-[var(--accent)] focus:border-transparent transition-all', error && 'border-[var(--danger)]', className)}
        {...props}
      >
        {placeholder && <option value="">{placeholder}</option>}
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>
      {error && <p className="text-xs text-[var(--danger)]">{error}</p>}
    </div>
  );
}
